<template>
	<div class="modal fade upload-modal" tabindex="-1" role="dialog" id="upload-modal">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
					<h4 class="modal-title">Upload Files</h4>
				</div>
				<div class="modal-body">
					<div>
						<input type="file" @change="handleFileChange">
						<table class="table file-table">
							<tbody>
								<tr v-for="file in uploadFiles">
									<td>{{file.name}}</td>
									<td>{{formatSizeUnits(file.size)}}</td>
									<td>{{file.progress}}%</td>
									<td><button type="button" class="btn btn-xs btn-primary" @click="handleUploadFile(file)">Upload</button></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary" @click="hideModal()">Close</button>
					<button type="button" class="btn btn-primary hide" @click="uploadItem(file)">Upload</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import _ from 'lodash'
export default {
	props: ['show'],
	data() {
		return {
			uploadFiles: []
		}
	},
	computed: {
		...mapGetters(['bases']),
	},
	methods: {
		handleFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			this.uploadFiles = [];
			_.each(files, file => this.uploadFiles.push(file));
		},
		async handleUploadFile(file){
			console.log(file);
			file.progress = 0;
			const uploadDataUrl = `${this.bases.fileApi}/files/getuploadurl?mimeType=${file.type}`;
			const uploadData = await this.$http.get(uploadDataUrl);
			const uploadUrl = uploadData.body.url;
			const config = {
				headers: {
					'Content-Type': file.type
				},
            	onUploadProgress: (progressEvent) => {
              		file.progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
					console.log(file.progress);
					this.$forceUpdate();
            	}
          	};
			const uploadResults = await axios.put(uploadData.body.url, file, config);
			this.$emit("uploadcomplete", {
				file,
				uploadUrl
			});
			this.uploadFiles = [];
		},
		formatSizeUnits(bytes){
			if      (bytes>=1000000000) {bytes=(bytes/1000000000).toFixed(2)+' GB';}
			else if (bytes>=1000000)    {bytes=(bytes/1000000).toFixed(2)+' MB';}
			else if (bytes>=1000)       {bytes=(bytes/1000).toFixed(2)+' KB';}
			else if (bytes>1)           {bytes=bytes+' bytes';}
			else if (bytes==1)          {bytes=bytes+' byte';}
			else                        {bytes='0 byte';}
			return bytes;
		},
		hideModal() {
			$('.upload-modal').modal('hide');
		},
		showModal() {
			$('.upload-modal').modal('show');
		}
	},
	watch: {
		show() {
			this.showModal();
		}
	}
}
</script>
<style>
.file-table {
	margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// Upload.vue?0af13458